import {changePageTitle, setAlert} from "../redux/actions";
import {HolidayService} from "./holiday.service";
import CustomTextField from "../custom-text-field/custom-text-field";
import CustomButton from "../custom-button/custom-button";
import CustomButtonGroup from "../custom-button-group/custom-button-group";
import {Holiday} from "./holiday";
import React, {FormEvent, useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";

interface HolidayDetailProps {
    id?: number | null;
    dialog?: boolean;
    onClose?: (holiday?: Holiday) => void;
}

export function HolidayDetail({id, dialog, onClose}: HolidayDetailProps) {

    const [item, setItem] = useState(HolidayService.createHoliday());
    const dispatch = useDispatch();

    const findOne = useCallback(async (id: number) => {
        const result = await HolidayService.findOne(id);
        setItem(result);
    }, []);

    useEffect(() => {
        if (!dialog) {
            dispatch(changePageTitle(id ? "Estado " + id : "Novo estado"));
        }
        if (id) {
            findOne(id).then();
        }
    }, [id, dialog]); // eslint-disable-line react-hooks/exhaustive-deps

    const save = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        HolidayService.save(item).then((result) => {
            if (onClose) {
                onClose(result.data);
            }
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao salvar registro - ' + error.response.data.message,
                severity: 'error'
            }));
        })
    }

    const cancel = () => {
        if (onClose) {
            onClose();
        }
    }

    const setDescription = (event: React.ChangeEvent<HTMLInputElement>) => {
        setItem({
            ...item,
            description: event.target.value
        })
    }

    const setDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        setItem({
            ...item,
            date: event.target.value
        })
    }

    return (
        <form onSubmit={save}>
            <CustomTextField fullWidth autoFocus required label="Descrição" value={item.description}
                             onChange={setDescription}/>
            <CustomTextField fullWidth required label="Data" type="date" value={item.date}
                             InputLabelProps={{shrink: true}} onChange={setDate}/>
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Salvar</CustomButton>
                <CustomButton type="button" color="neutral" onClick={cancel}>Cancelar</CustomButton>
            </CustomButtonGroup>
        </form>
    )

}
